import {Routes} from 'constants/routes';

import {useEffect} from 'react';

import {faPen, faSort} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import LayoutPage from 'layouts/LayoutPage/LayoutPage';
import InfiniteScroll from 'react-infinite-scroll-component';
import {useNavigate} from 'react-router';
import {setNavigationTitleAC} from 'store/app/appSlice';
import {setPageEditorFiltersAC, pageEditorsPerPage} from 'store/pageEditors/pageEditorSlice';
import {getPageEditorsACS} from 'store/pageEditors/requestAC';
import PubBase from 'typescript/models/PubBase';

import './PageEditors.scss';

import NavbarContent from './NavbarContent';

const PageEditors = () => {
  const dispatch = useSetGlobalState();
  const navigate = useNavigate();

  const {pageEditors, filters, pageEditorsMeta} = useGlobalState((state) => state.pageEditors);

  useEffect(() => {
    dispatch(getPageEditorsACS(filters));
    // eslint-disable-next-line
  }, [filters]);

  useEffect(() => {
    dispatch(setNavigationTitleAC('PAGE EDITORS'));

    // eslint-disable-next-line
  }, []);

  const renderPubPageCellText = (pubs: PubBase[]) => {
    if (!pubs.length) return 'No pubs assigned';

    if (pubs.length > 1) return `${pubs[0].name}...+${pubs.length - 1}`;

    return pubs[0].name;
  };

  const handleInfiniteScrollNext = () => {
    dispatch(
      setPageEditorFiltersAC({
        ...filters,
        page: 1,
        perPage: pageEditors.length + pageEditorsPerPage,
      }),
    );
  };

  const handleNicknameFilter = () => {
    dispatch(
      setPageEditorFiltersAC({
        ...filters,
        column: 'nickname',
        direction: filters.direction === 'asc' ? 'desc' : 'asc',
      }),
    );
  };

  return (
    <LayoutPage navbarChildren={<NavbarContent searchValue={filters.name} />}>
      <div className="page-editors">
        <InfiniteScroll
          dataLength={pageEditors.length}
          hasMore={pageEditorsMeta?.next_page !== null}
          next={handleInfiniteScrollNext}
          height={790}
          className="page-editors__table-wrapper"
          loader={
            <div className="page-editors__loader">
              <div className="spinner-border" />
            </div>
          }
        >
          <table className="page-editors__table">
            <thead className="page-editors__table-head">
              <tr className="page-editors__table-row">
                <th className="page-editors__table-nickname-cell">
                  Nickname
                  <button onClick={handleNicknameFilter}>
                    <FontAwesomeIcon icon={faSort} />
                  </button>
                </th>
                <th>Email</th>
                <th>Phone number</th>
                <th colSpan={2}>Pub page</th>
              </tr>
            </thead>
            <tbody className="page-editors__table-body">
              {pageEditors.map((pageEditor) => (
                <tr
                  className={`page-editors__table-row ${
                    !pageEditor.attributes.pubs.length && 'page-editors__table-row--disabled'
                  }`}
                  onClick={() => navigate(`${Routes.EDITORS_VIEW}/${pageEditor.id}`)}
                  key={pageEditor.id}
                >
                  <td className="page-editors__table-cell-nickname">{pageEditor.attributes.nickname || '/'}</td>
                  <td>{pageEditor.attributes.email}</td>
                  <td>{pageEditor.attributes.phone || '/'}</td>
                  <td>{renderPubPageCellText(pageEditor.attributes.pubs)}</td>
                  <td className="page-editors__table-cell-edit">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`${Routes.EDITORS_EDIT}/${pageEditor.id}`);
                      }}
                    >
                      <FontAwesomeIcon icon={faPen} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </InfiniteScroll>
      </div>
    </LayoutPage>
  );
};

export default PageEditors;
